<template>
  <div>
    <a-modal :visible="videoShow" :footer="null" :title="videoTitle" @cancel="modalCancel()">
      <div class="video-con" v-html="videoHtml">

      </div>
    </a-modal>
  </div>
</template>

<script>
import utils from "../../../assets/js/utils";
export default {
  props: {
    videoShow: {
      type: Boolean
    },
    videoTitle: {
      type: String,
    },
    videoInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      videoHtml: ""
    }
  },
  mounted() {
    // $(".ant-modal-header")
    if (this.videoInfo) {
      window.addEventListener("resize", () => {
        this.setHeaderTitle()
      })
    }


  },
  methods: {
    modalCancel() {
      this.$emit("closeModal")
    },
    setHeaderTitle() {
      let header = document.querySelector(".ant-modal-header")
      let titleText = document.querySelector(".ant-modal-title")
      let headerWidth = header.getBoundingClientRect().width
      let titleWidth = titleText.getBoundingClientRect().width
      if (titleWidth > headerWidth) {
        console.log(6766);
        titleText.className = `ant-modal-title scroll`
      }else {
         titleText.className = `ant-modal-title`
      }
    },
    initVideoFile(elemId, qclude_id, appId) {
      utils.loadScript(
        window.location.origin + "/vod/hls.min.0.12.4.js",
        () => {
          utils.loadScript(
            window.location.origin + "/vod/tcplayer.min.js",
            () => {
              if (typeof window.TCPlayer === "function") {
                this.activePlaying = window.TCPlayer(elemId, {
                  // player-container-id 为播放器容器ID，必须与html中一致
                  fileID: qclude_id, // 请传入需要播放的视频filID 必须
                  // fileID: "5285890807937512700",
                  controls: true,
                  muted: true,
                  // playbackRates: [0.5, 1, 1.25, 1.5, 2],
                  appID: appId, // 请传入点播账号的appID 必须
                  // width: utils.isMobile() ? 355 : 720, //视频的显示宽度
                  // height: utils.isMobile() ? 300 : 403, //视频的显示高度
                  definition: 30,
                  autoplay: false,
                  plugins: {
                    // ContinuePlay: {
                    // 	// 开启续播功能
                    // 	auto: true, //[可选] 是否在视频播放后自动续播
                    // 	text: "上次播放至 ", //[可选] 提示文案
                    // 	btnText: "恢复播放", //[可选] 按钮文案
                    // },
                  },
                  // controlBar: {
                  //   playbackRateMenuButton: false
                  // }
                });
              }
            }
          );
        }
      );


    },
  },
  watch: {
    videoInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal.tencent_vod_file_id && newVal.tencent_vod_app_id) {
          let id = `v-${newVal.tencent_vod_file_id}${+ new Date()}`
          this.videoHtml = `<video id="${id}" :data-fileid="${newVal.tencent_vod_file_id}"
                :data-appid="${newVal.tencent_vod_app_id}" style="width: 100%;height: 100%"></video>`
          this.$nextTick(() => {
            this.setHeaderTitle()
            this.initVideoFile(id, newVal.tencent_vod_file_id, newVal.tencent_vod_app_id)

          })
        }

      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  width: calc(52vw + 48px) !important;
}
/deep/ .ant-modal-content {
  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 140px;
    background: linear-gradient(180deg, #cce2ff 0%, #ffffff 100%);
    border-radius: 4px 4px 0px 0px;
  }
  .ant-modal-body {
    position: relative;
    z-index: 1;
  }
}
/deep/ .ant-modal-header {
  padding: 28px 0 0 0;
  margin: 0 40px 4px 24px;
  overflow: hidden;
  border-bottom: 0;
  position: relative;
  z-index: 1;
  background-color: transparent;
}
/deep/ .ant-modal-title {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  white-space: nowrap;
  width: fit-content;
  &.scroll {
    animation: textscroll 8s linear infinite ;
  }
}
/deep/ .ant-modal-close {
  top: 32px;
  right: 24px;
  width: 16px;
  height: 16px;
  background-image: url("../../../assets/image/kjqg/common/modal-close.png");
  &:hover {
    background-image: url("../../../assets/image/kjqg/common/modal-close-hover.png");
  }
  .ant-modal-close-x {
    display: none;
  }
}

.video-con {
  width: 52vw;
  height: 29.3vw;
  .tcplayer {
    width: 100% !important;
    height: 100% !important;
  }
  video {
    width: 100%;
    height: 100%;
  }
}
@keyframes textscroll {
  0% {
    transform: translateX(50%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>